const t = {
  type: [Array, String, Object],
  default: ""
};
export {
  t as ClassProp
};
